<template>
  <v-dialog v-model="showDialog" max-width="600px">
    <template v-slot:activator="{ on }">
      <v-btn class="mx-2" small fab dark color="white" v-on="on">
        <v-icon color="info">mdi-security</v-icon>
      </v-btn>
    </template>
    <v-card v-if="showDialog">
      <s-toolbar :text="'Modifier les rôles  de ' + employe.nomComplet" update @close="close()" />
      <v-card-text>
        <est-delegue-du-personnel-form
          :employe-id="employe.employeId"
          :est-delegue-du-personnel="employe.delegueDuPersonnel"
        />
        <est-delegue-syndical-form :employe-id="employe.employeId" :est-delegue-syndical="employe.delegueSyndical" />
        <est-administrateur-etablissement-form
          :employe-id="employe.employeId"
          :est-administrateur="employe.administrateur"
        />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'
import EstDelegueDuPersonnelForm from '@/components/employe/EstDelegueDuPersonnelForm.vue'
import EstDelegueSyndicalForm from '@/components/employe/EstDelegueSyndicalForm.vue'
import EstAdministrateurEtablissementForm from '@/components/employe/EstAdministrateurEtablissementForm.vue'

export default {
  name: 'employe-roles-dialog',
  components: {
    EstAdministrateurEtablissementForm,
    EstDelegueSyndicalForm,
    EstDelegueDuPersonnelForm,
  },
  props: {
    employe: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      showDialog: false,
      updateEmployeCommand: undefined,
      formValid: true,
    }
  },
  created() {
    this.initialize()
  },
  watch: {
    employe() {
      this.initialize()
    },
  },
  methods: {
    ...mapActions({
      updateEmploye: 'employe/updateEmploye',
    }),
    initialize() {
      this.updateEmployeCommand = {
        employeId: this.employe.employeId,
        emailPro: this.employe.emailPro,
        delegueDuPersonnel: this.employe.delegueDuPersonnel,
        delegueSyndical: this.employe.delegueSyndical,
        administrateur: this.employe.administrateur,
        soldeRecupInitial: this.employe.soldeRecupInitial,
        dateEntreeAnciennete: this.employe.dateEntreeAnciennete,
      }
    },
    close() {
      this.initialize()
      this.showDialog = false
    },
    updateFormValid(_validity) {
      this.formValid = _validity
    },
    sendUpdateEmploye() {
      this.updateEmploye(this.updateEmployeCommand)
      this.close()
    },
  },
}
</script>

<style scoped></style>
